import React, { useRef, useEffect } from "react";
import { TimelineContent } from "../components/ui/timeline-animation";
import { FiZap as Zap } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

export default function AboutPage() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const heroRef = useRef(null);
  
  const revealVariants = {
    visible: (i) => ({
      y: 0,
      opacity: 1,
      filter: "blur(0px)",
      transition: {
        delay: i * 1.0,
        duration: 0.7,
      },
    }),
    hidden: {
      filter: "blur(10px)",
      y: 40,
      opacity: 0,
    },
  };

  const textVariants = {
    visible: (i) => ({
      filter: "blur(0px)",
      opacity: 1,
      transition: {
        delay: i * 0.3,
        duration: 0.7,
      },
    }),
    hidden: {
      filter: "blur(10px)",
      opacity: 0,
    },
  };

  return (
    <div className="pt-32 pb-12 w-full min-h-screen bg-slate-50">
      <section className="py-20 px-4 min-h-[70vh] flex items-center">
        <div className="max-w-6xl mx-auto" ref={heroRef}>
          <div className="flex flex-col lg:flex-row items-start gap-8">
            <div className="flex-1">
              <TimelineContent
                as="h1"
                animationNum={0}
                customVariants={revealVariants}
                className="sm:text-4xl text-3xl md:text-6xl lg:text-[72px] !leading-[1.15] font-bold text-slate-900 mb-8"
              >
                We are{" "}
                <TimelineContent
                  as="span"
                  animationNum={1}
                  customVariants={textVariants}
                  className="text-brand-gradient border-2 border-blue-500/30 inline-block xl:h-20 border-dotted px-4 rounded-xl"
                >
                  rethinking
                </TimelineContent>{" "}
                digital infrastructure to be more reliable and always you-first. Our
                goal is to continually raise the bar and{" "}
                <TimelineContent
                  as="span"
                  animationNum={2}
                  customVariants={textVariants}
                  className="text-brand-gradient border-2 border-indigo-500/30 inline-block xl:h-20 border-dotted px-4 rounded-xl"
                >
                  challenge
                </TimelineContent>{" "}
                how things could{" "}
                <TimelineContent
                  as="span"
                  animationNum={3}
                  customVariants={textVariants}
                  className="text-brand-gradient border-2 border-violet-500/30 inline-block xl:h-20 border-dotted px-4 rounded-xl"
                >
                  work for you.
                </TimelineContent>
              </TimelineContent>

              <div className="mt-16 flex flex-col sm:flex-row gap-6 justify-between items-start sm:items-center">
                <TimelineContent
                  as="div"
                  animationNum={4}
                  customVariants={textVariants}
                  className="mb-4 sm:text-xl text-base"
                >
                  <div className="font-medium text-slate-900 mb-1 capitalize">
                    We are HostFig and we will
                  </div>
                  <div className="text-brand-gradient font-bold uppercase tracking-widest">
                    take you further
                  </div>
                </TimelineContent>

                <TimelineContent
                  as="button"
                  onClick={() => navigate('/contact')}
                  animationNum={5}
                  customVariants={textVariants}
                  className="bg-brand-gradient gap-2 font-semibold shadow-lg shadow-blue-600/20 text-white h-14 px-8 rounded-full text-base inline-flex items-center cursor-pointer hover:scale-105 transition-transform"
                >
                  <Zap fill="white" size={18} />
                  About HostFig
                </TimelineContent>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}